import conf from '../config'

export const API_ROOT = `${conf.api}`

export const refreshTokenUrl = {
    refreshTokenUrl: `${API_ROOT}/auth/refresh`
}
export default refreshTokenUrl